import http from './http.js'
/**
 * post、get、put
 * http.post('url', params, 'query');
 * url:接口
 * params:参数
 * query:传参格式，默认为 data(body)传参，
 *      设置 query 为 params(query)传参，格式为：url?xx=xx
 * queryAndBody: 参数是否包含两个格式  query、body
 *    默认：false,
 *    如果设置为true
 *    参数形式如下，bodyObject内参数会在body传参，params 参数为 url?xxx=xxx
 *    params={
 *      xxx:xxx,
 *      bodyObject:String
 *    }
 */
// 获取聊天记录
export const getChartData = params => {
  return http.get('/api/user/chat-log', params, 'query')
}
// 设置消息为已读
export const setReadMsg = params => {
  return http.post('/api/user/check-un-read-chat-log', params)
}
// 上传文件
export const uploadFile = params => {
  return http.postForm('/sysFileInfo/upload', params)
}
// 获取群信息
export const getGroupDetailApi = params => {
  return http.get(`/api/group/group-by-id/${params.id}`, params)
}
// 解散群
export const deleteGroupApi = params => {
  return http.post('/api/group/delete', params)
}
// 退出群
export const deleteGroupUser = params => {
  return http.post('/api/group/exit-group', params)
}
// 移出成员
export const moveOutGroupUser = params => {
  return http.post('/api/group/move-out-group', params)
}
// 加入群
export const joinGroup = params => {
  return http.post('/api/group/join-group', params)
}
// 创建群
export const createGroup = params => {
  return http.post('/api/group/group', params)
}
// 拉人进群
export const addPeopleToGroup = params => {
  return http.post('/api/group/invite-group', params)
}
// 同步用户数据
export const batchUserData = params => {
  return http.post('/api/user/batch-create-or-update', params)
}
// 判断群组是否已存在
export const isExistGroup = params => {
  return http.get(`/api/group/exist-group/${params.id}/${params.type}/${params.userid}`)
}
// 获取视频token
export const getVideoToken = params => {
  return http.get('/api/system/token', params)
}
// 用token获取一体化用户信息
export const getUserInfoYT = params => {
  return http.post('/api/Jwt/GetUserByToken', params)
}
// 语音转文字
/* export const voiceToWordApi = params => {
  return http.postOther('', params)
} */
export const voiceToWordApi = params => {
  return http.fetchEvent(params)
}
// 关闭会话
export const closeGroup = params => {
  return http.post('/api/group/close-group', params)
}
// 获取剩余会话次数
export const getQuestRemainNum = params => {
  return http.get(`/api/user/number-of-remaining-questions/${params.groupid}/${params.userid}`)
}
// 上传文件
export const uploadFileApi = params => {
  return http.postForm('/sysFileInfo/upload', params)
}
// 发送消息接口----只发送chaType为7的消息，即病历消息
export const clinicalInformation = params => {
  return http.post('/api/group/send-clinical-information', params)
}
// 重启会话
export const reStartGroup = params => {
  return http.post('/api/group/re-start-group', params)
}
// 消息撤回
export const messageReCall = params => {
  return http.post(`/api/user/message-re-call/${params.userId}/${params.messageId}`, params)
}
// 发送消息接口---所有消息类型都可发送
export const sendMessageToGroup = params => {
  return http.post('/api/group/send-message-to-group', params)
}
// 获取用户以及群组列表
export const lastUsersAndGroups = params => {
  return http.get(`/api/user/last-users-and-groups/${params.userid}/${params.ignoreusers}`)
}
// 登录接口
export const systemLogin = params => {
  return http.post('/api/system/login', params)
}
// 获取用户信息
export const sysUserInfo = params => {
  return http.post('/api/system/user-info', params)
}
// 修改组别信息
export const changeUserTeam = params => {
  return http.post('/api/system/change-user-team', params, 'query')
}
// 兰天球接口--获取患者咨询详情
export const getPatientConInfo = params => {
  return http.get(`/api/system/detail-by-chat-room/${params.id}`, params, 'query')
}
// 接口获得登录参数
export const createAskChatRoomParams = params => {
  return http.post('/api/system/ask-chat-room-params', params)
}



// WEBPACK FOOTER //
// ./packages/api/api.js